<p-dialog 
  header="Contact Us" 
  [(visible)]="visible" 
  [modal]="true" 
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="contact-form-dialog"
  [style]="{width: '800px', maxWidth: '90vw'}"
  (onHide)="onClose()">
  
  <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
    <div class="form-row">
      <div class="form-field">
        <label for="name">Name <span class="required">*</span></label>
        <div *ngIf="isLoadingUserInfo" class="skeleton-loader"></div>
        <input 
          *ngIf="!isLoadingUserInfo"
          pInputText 
          id="name" 
          formControlName="name" 
          placeholder="Enter your name"
          [class.ng-invalid]="contactForm.get('name')?.invalid && contactForm.get('name')?.touched" />
        <small class="error-message" *ngIf="contactForm.get('name')?.invalid && contactForm.get('name')?.touched">
          <span *ngIf="contactForm.get('name')?.errors?.['required']">Name is required</span>
          <span *ngIf="contactForm.get('name')?.errors?.['xss']">Invalid characters detected</span>
        </small>
      </div>

      <div class="form-field">
        <label for="email">Email <span class="required">*</span></label>
        <div *ngIf="isLoadingUserInfo" class="skeleton-loader"></div>
        <input 
          *ngIf="!isLoadingUserInfo"
          pInputText 
          id="email" 
          formControlName="email" 
          placeholder="Enter your email"
          [class.ng-invalid]="contactForm.get('email')?.invalid && contactForm.get('email')?.touched" />
        <small class="error-message" *ngIf="contactForm.get('email')?.invalid && contactForm.get('email')?.touched">
          <span *ngIf="contactForm.get('email')?.errors?.['required']">Email is required</span>
          <span *ngIf="contactForm.get('email')?.errors?.['email']">Please enter a valid email</span>
        </small>
      </div>
    </div>

    <div class="form-field">
      <label for="subject">Subject <span class="required">*</span></label>
      <input 
        pInputText 
        id="subject" 
        formControlName="subject" 
        placeholder="Enter subject"
        [class.ng-invalid]="contactForm.get('subject')?.invalid && contactForm.get('subject')?.touched" />
      <small class="error-message" *ngIf="contactForm.get('subject')?.invalid && contactForm.get('subject')?.touched">
        <span *ngIf="contactForm.get('subject')?.errors?.['required']">Subject is required</span>
        <span *ngIf="contactForm.get('subject')?.errors?.['xss']">Invalid characters detected</span>
      </small>
    </div>

    <div class="form-field">
      <label for="message">Message <span class="required">*</span></label>
      <textarea 
        pInputTextarea 
        id="message" 
        formControlName="message" 
        rows="8" 
        placeholder="Enter your message"
        [class.ng-invalid]="contactForm.get('message')?.invalid && contactForm.get('message')?.touched">
      </textarea>
      <small class="error-message" *ngIf="contactForm.get('message')?.invalid && contactForm.get('message')?.touched">
        <span *ngIf="contactForm.get('message')?.errors?.['required']">Message is required</span>
        <span *ngIf="contactForm.get('message')?.errors?.['xss']">Invalid characters detected</span>
      </small>
    </div>

  </form>
  
  <ng-template pTemplate="footer">
    <p-button 
      label="Cancel" 
      icon="pi pi-times" 
      styleClass="p-button-text" 
      (onClick)="onClose()" 
      type="button">
    </p-button>
    <p-button 
      label="Send Message" 
      icon="pi pi-send" 
      [loading]="isSubmitting"
      [disabled]="contactForm.invalid"
      (onClick)="onSubmit()">
    </p-button>
  </ng-template>
</p-dialog>